import React from "react";
import "./Footer.css";
import { Form, InputGroup, NavLink } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faGoogle,
  faLinkedinIn,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const socialIcons = [
    { icon: faFacebookF, link: "https://www.facebook.com" },
    { icon: faGoogle, link: "https://www.google.com" },
    { icon: faXTwitter, link: "https://www.twitter.com" },
    { icon: faLinkedinIn, link: "https://www.linkedin.com" },
  ];

  const handleNavClick = (path, e) => {
    e.preventDefault();

    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: "auto" });
    } else {
      navigate(path);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
      }, 200);
    }
  };

  return (
    <>
      <footer className="Footer two_section_holder">

        <div className="whatsappicon">
          <a target="_blank" class="webwhats" href="https://web.whatsapp.com/send?phone=8793449778"><img class="whatsapp-img" src="/assets/images/footer/whatsapp.png" /></a>
          
          <a target="_blank" class="mobwhats" href="https://wa.me/8793449778"><img class="whatsapp-img" src="/assets/images/footer/whatsapp.png" /></a>
        </div>

        <div className="container">

          <div className="row ">
            {/* Logo */}
            <div className="col-lg-3  col-sm-12 mb-4">
              <div className="logo_holder">
                <img
                  src="/assets/images/logo/logo.png"
                  alt="Logo"
                  className="logo_img"
                />
              </div>
              <div className="logo_text_holder">
                <p className="logo_text">
                  Established in 2018, Shore Clinic is a DG Shipping (Govt. of
                  India)–approved and ISO 9001:2015 & 45001:2018 certified
                  maritime medical centre in Pune. We ensure the health, safety,
                  and fitness of seafarers through ethical, accurate, and
                  compliant medical assessments.
                </p>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-4 col-sm-4 col-6 mb-4 col_div">
              <h5 className="footer_section_title">Quick Links</h5>
              <div className="footer_links quick_links">
                {[
                  { label: "Home", path: "/" },
                  { label: "About Us", path: "/about-us" },
                  { label: "Services", path: "/services" },
                  { label: "Our Clients", path: "/our-clients" },
                  // { label: "Blogs", path: "/blogs" },
                  { label: "Contact Us", path: "/contact" },
                ].map((item) => (
                  // <NavLink
                  //   key={item.path}
                  //   as={Link}
                  //   to={item.path}
                  //   onClick={(e) => handleNavClick(item.path, e)}
                  //   className={`footer_link ${
                  //     location.pathname === item.path
                  //       ? "active_footer_link"
                  //       : ""
                  //   }`}
                  // >
                  //   {item.label}
                  // </NavLink>

                  <NavLink
                    key={item.path}
                    as={Link}
                    to={item.path}
                    onClick={(e) => handleNavClick(item.path, e)}
                    className={`footer_link ${item.path === "/"
                      ? location.pathname === "/"
                        ? "active_footer_link"
                        : ""
                      : location.pathname.startsWith(item.path)
                        ? "active_footer_link"
                        : ""
                      }`}
                  >
                    {item.label}
                  </NavLink>
                ))}
              </div>
            </div>

            {/* Follow Us */}
            <div className="col-lg-2 col-md-4 col-sm-4 col-6 mb-4 col_div">
              <h5 className="footer_section_title">Follow Us</h5>
              <div className="footer_links">
                {[
                  { label: "Facebook", link: "https://www.facebook.com" },
                  { label: "Instagram", link: "https://www.instagram.com" },
                  { label: "Twitter", link: "https://www.twitter.com" },
                  { label: "Youtube", link: "https://www.youtube.com/" },
                ].map((item, index) => (
                  <a
                    key={index}
                    href={item.link}
                    className="footer_link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>

            {/* Support */}
            <div className="col-lg-2  col-sm-4 col-12 mb-4 col_div">
              <h5 className="footer_section_title">Address</h5>
              <div className="footer_links">
                <NavLink
                  as={Link}
                  to="#"
                  // onClick={(e) => handleNavClick("/terms-conditions", e)}
                  className="footer_link"
                >
                  Office No.1, Dnyanesh Height, Sr.no.209, Near Shivaji Maharaj
                  Statue, Kothrud Pune-411038
                </NavLink>
              </div>
            </div>

            {/* Newsletter */}
            {/* <div className="col-lg-3 col-sm-6 col-12 col_div">
              <h5 className="footer_section_title">Newsletter</h5>
              <div className="footer_links">
                <NavLink className="footer_link">
                  Join our community of seafarers, marine institutes, and
                  shipping companies who rely on trusted health information.
                </NavLink>
              </div>
              <InputGroup className="mt-3 input-group">
                <Form.Control placeholder="Enter Email" aria-label="email" />
                <InputGroup.Text id="basic-addon2">
                  <div className="img_holder">
                    <img
                      src="/assets/images/footer/right-arrow.png"
                      className="arrow"
                      alt="submit arrow"
                    />
                  </div>
                </InputGroup.Text>
              </InputGroup>
            </div> */}

            {/* social icons */}

            {/* <div className="icons_holder">
                {socialIcons.map((item, index) => (
                  <div className="squr_box" key={index}>
                    <div className="icon_holder">
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="link"
                      >
                        <FontAwesomeIcon
                          icon={item.icon}
                          className="icon_class"
                        />
                      </a>
                    </div>
                  </div>
                ))}
              </div> */}

            <div className="col-lg-3 col-sm-6 col-12 col_div">
              <h5 className="footer_section_title">Contact</h5>
              <div className="footer_links">
                <p className="footer_link">
                  Phone No :- 8793449778 / 8208520589 <br />
                  Clinic No :- 7261980885
                </p>

              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="container">
          <div className="footer_text_div">
            <p className="footer_text">
              ©2026 Shore Clinic All Rights Reserved. Developed by
              <a
                href="https://profcymaglobal.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="link_text"
              >
                Profcyma Solutions Pvt Ltd
              </a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
